import styles from './HeaderSection.module.css';
import {Placeholder, Section} from "@telegram-apps/telegram-ui";

const PlaceholderImage = () => (
    <img
        alt="Rentstation"
        src="https://rentstation.ru/static/img/rs.png"
        style={{ width: 'auto', height: '50px', display: 'block' }}
    />
);

export const HeaderSection = () => (
<Section className={styles.section}>
    <Placeholder header="Аренда спортивного инвентаря">
        <PlaceholderImage />
    </Placeholder>
</Section>
);